/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".achievement[_ngcontent-%COMP%]{height:100%;background:#3a4e6b!important}.achievement[_ngcontent-%COMP%]   .icon[_ngcontent-%COMP%]{margin:14px 0}.achievement[_ngcontent-%COMP%]   h3[_ngcontent-%COMP%]{margin:0;font-size:1em}"];
export { styles as styles };
